<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 14:47:51
 * @LastEditTime: 2025-12-03 19:15:27
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-content">
    <div class="content_wrap">
      <template v-if="activeRouteProp === null">
        <SuggestQuestion v-bind="$attrs" :source="source" :sourceType="sourceType" v-on="$listeners"></SuggestQuestion>
      </template>
      <template v-else>
        <Dialogue v-bind="$attrs" v-on="$listeners"></Dialogue>
      </template>
    </div>
    <div class="zzpBtns" v-if="!source">
      <template v-for="(item, i) in $store.state.aiChat.zzpSelectBtn">
        <el-tooltip
          :content="item.content"
          placement="top"
          overflow
          :open-delay="300"
          :key="i"
          v-if="item.type === 6 || item.type === 7"
        >
          <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i">
            {{ getBtnName(item) }}
            <i class="el-icon-error" @click.stop="delBtn(i)"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip placement="top" overflow :open-delay="300" :key="i" v-else-if="item.type === 3">
          <div slot="content">
            <div v-html="dynamicHtml(item)"></div>
          </div>
          <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i">
            {{ getBtnName(item) }}
            <i class="el-icon-error" @click.stop="delBtn(i)"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip placement="top" overflow :open-delay="300" :key="i" v-else-if="item.type === 4 || item.type === 5">
          <div slot="content">
            <div>{{ getRecordingTooltip(item) }}</div>
          </div>
          <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i">
            {{ getBtnName(item) }}
            <i class="el-icon-error" @click.stop="delBtn(i)"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip
          :content="item.content"
          placement="top"
          overflow
          :open-delay="300"
          :key="i"
          v-else-if="item.type === 8"
        >
          <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i">
            {{ getBtnName(item) }}
            <i class="el-icon-error" @click.stop="delBtn(i)"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip placement="top" overflow :open-delay="300" :key="i" v-else-if="item.type === 9">
          <div slot="content">
            <div>{{ getProfileTooltip(item) }}</div>
          </div>
          <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i">
            {{ getBtnName(item) }}
            <i class="el-icon-error" @click.stop="delBtn(i)"></i>
          </el-button>
        </el-tooltip>

        <el-button type="plain" size="small" @click="zzpBtnsClick(item)" :key="i" v-else>
          {{ getBtnName(item) }}
          <i class="el-icon-error" @click.stop="delBtn(i)"></i>
        </el-button>
      </template>

      <el-dropdown @command="handleCommand" trigger="click">
        <el-button type="primary" size="small" icon="el-icon-plus-bold">素材</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, i) in zzpBtnList"
            :key="i"
            :command="item.value"
            :disabled="btnIsDisabled(item)"
            >{{ item.label }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="source-select-wrap" v-if="(source === 'global' || source === 'wenshu') && showSourceSelect">
      <el-select v-model="sourceType" size="small" placeholder="请选择" :disabled="$store.state.aiChat.textareaIsDisabled">
        <el-option label="AI员工" value="global"></el-option>
        <el-option label="AI问数" value="wenshu"></el-option>
      </el-select>
    </div>
    <div class="textarea_wrap">
      <CustomTextArea :source="source" :sourceType="sourceType" v-bind="$attrs" v-on="$listeners"> </CustomTextArea>
    </div>
    <el-dialog
      ref="dialog"
      class="recording_dialog"
      title="录音选择"
      :append-to-body="true"
      :visible.sync="visible"
      width="600px"
      @close="dialogClose"
    >
      <div class="recording-box file-list" v-loading="loading">
        <div
          class="file-item"
          v-for="(item, index) in fileList"
          :key="index"
          :class="[
            selectRecordingIds.includes(item.id) ? 'selectRecording' : '',
            recordingIsSelect(item) ? 'recordingNoSelect' : ''
          ]"
          @click="selectRecordingFn(item)"
        >
          <div class="fileItemHeader">
            <div class="file-item-l">
              <div class="file-item-l01">
                <svg class="icon svg-icon file-type" aria-hidden="true">
                  <use xlink:href="#icon-MP3"></use>
                </svg>
                <el-tooltip :content="item.name" placement="top" overflow>
                  <span class="file-item-name">{{ item.name }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="file-item-r" v-if="$store.state.app.equityIds.includes('536')">
              <el-button
                type="text"
                size="mini"
                @click.stop="convertAudioToText(item)"
                v-if="
                  (item.multipartUploadRecordDTO === null && item.taskStatus === 0) ||
                  item.taskStatus === 3 ||
                  (item.multipartUploadRecordDTO &&
                    item.multipartUploadRecordDTO.transCode === 'Success' &&
                    item.taskStatus === 0)
                "
                style="color: #165dff"
              >
                异步录音转文字
              </el-button>
              <div
                class="file-item-r recording"
                v-if="
                  item.taskStatus === 1 ||
                  (item.multipartUploadRecordDTO &&
                    item.multipartUploadRecordDTO.transCode != 'Success' &&
                    item.multipartUploadRecordDTO.state !== 0)
                "
              >
                转化文字中
              </div>
            </div>
          </div>
        </div>
        <div class="content-empty" v-if="fileList.length === 0">
          <img :src="require('@/assets/images/followempty.png')" alt="" />
          <p>暂无数据</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" size="small" @click="dialogClose">取消</el-button>
        <el-button type="primary" size="small" @click="saveConfirm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 关联测评弹窗 -->
    <el-dialog
      title="关联测评"
      :visible.sync="evaluationDialogVisible"
      width="1000px"
      :title-height="48"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="evaluationDialogClose"
      class="related-evaluation"
    >
      <public-table
        ref="evaluationTable"
        class="publictable"
        :tableData="evaluationTableData"
        :tableColumns="evaluationTableColumns"
        :tableConfig="evaluationTableConfig"
        :paginationConfig="evaluationPaginationConfig"
        @handleSelectChange="handleEvaluationSelectChange"
        v-loading="evaluationTableLoading"
      >
        <!-- <el-table-column prop="userAssessStatus" slot="userAssessStatus" label="状态" width="100">
          <template slot-scope="{ row }">
            <span class="status" :style="{ background: getTaskStatusData(row.userAssessStatus).background }">{{
              getTaskStatusData(row.userAssessStatus).name
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="assessmentTools" slot="assessmentTools" label="测评工具" width="260">
          <template slot-scope="{ row }">
            <div class="tag-wrapper">
              <el-tag bg-type="grey" class="tag-more">{{
                row.currentReportInfo && row.currentReportInfo.scaleName
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
      </public-table>
      <span slot="footer" class="dialog-footer">
        <div class="btn-right">
          <el-button type="secondary" @click="evaluationDialogClose">取消</el-button>
          <el-button type="primary" @click="evaluationConfirm" :loading="evaluationLoading">确定</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- 职位画像管理 Drawer -->
    <el-drawer
      title="职位画像管理"
      :visible.sync="positionProfileDrawerVisible"
      direction="rtl"
      size="600px"
      :append-to-body="true"
      :modal-append-to-body="false"
      :wrapperClosable="true"
      custom-class="position-profile-drawer-wrapper"
    >
      <div class="position-profile-drawer">
        <div class="toolbar">
          <div class="toolbar-actions">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddForm">新增职位画像</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteSelected" :disabled="selectedProfileIds.size === 0">删除选中</el-button>
            <el-button type="default" size="small" @click="toggleSelectAll">{{ selectedProfileIds.size === profileList.length ? '取消全选' : '全选' }}</el-button>
          </div>

          <div class="selection-info" v-if="selectedProfileIds.size > 0">
            <i class="el-icon-check"></i>
            已选择 <strong>{{ selectedProfileIds.size }}</strong> 个职位画像
          </div>
        </div>

        <div class="content-area" v-loading="profileListLoading">
          <div class="profile-list" v-if="profileList.length > 0 && !profileListLoading">
            <div
              v-for="profile in profileList"
              :key="profile.id"
              class="profile-item"
              :class="{ 'selected': selectedProfileIds.has(profile.id) }"
              @click="handleCardClick($event, profile.id)"
            >
              <div class="profile-item-header">
                <el-checkbox
                  :value="selectedProfileIds.has(profile.id)"
                  @change="toggleSelection(profile.id)"
                  @click.native.stop
                ></el-checkbox>
                <span class="profile-name">{{ profile.profileName }}</span>
                <div class="profile-actions" @click.stop>
                  <el-button
                    type="text"
                    icon="el-icon-star-off"
                    :class="{ 'default-active': profile.isDefault }"
                    @click="toggleDefault(profile)"
                    :title="profile.isDefault ? '取消默认' : '设为默认'"
                    size="large"
                  ></el-button>
                  <el-button type="text" icon="el-icon-edit" @click="editProfile(profile.id)" title="编辑" size="large"></el-button>
                  <el-button type="text" icon="el-icon-delete" class="delete-btn" @click="deleteProfile(profile.id)" title="删除" size="large"></el-button>
                </div>
              </div>
              <div class="profile-content">{{ profile.profileContent }}</div>
            </div>
          </div>

          <div class="empty-state" v-else-if="profileList.length === 0 && !profileListLoading">
            <i class="el-icon-document" style="font-size: 64px; color: #dcdfe6;"></i>
            <div style="margin-top: 16px; color: #909399;">暂无职位画像，点击"新增职位画像"创建</div>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button @click="positionProfileDrawerVisible = false" type="plain">取消</el-button>
        <el-button type="primary" @click="confirmSelection">确定</el-button>
      </div>
    </el-drawer>

    <!-- 新增/编辑职位画像 Dialog -->
    <el-dialog
      :title="editingProfileId ? '编辑职位画像' : '新增职位画像'"
      :visible.sync="profileDialogVisible"
      width="600px"
      :append-to-body="true"
      @close="cancelEdit"
      v-loading="profileFormLoading"
    >
      <el-form :model="profileForm" ref="profileFormRef" :rules="profileFormRules" label-width="100px" class="profileDialogForm">
        <el-form-item label="画像名称" prop="profileName">
          <el-input v-model="profileForm.profileName" placeholder="请输入画像名称"></el-input>
        </el-form-item>
        <el-form-item label="画像内容" prop="profileContent">
          <el-input type="textarea" v-model="profileForm.profileContent" placeholder="请输入画像内容描述" :rows="6" :maxLength="300" :show-word-limit="true"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit" :disabled="profileFormLoading">取消</el-button>
        <el-button type="primary" @click="saveProfile" :loading="profileFormLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SuggestQuestion from './suggestQuestion.vue'
import Dialogue from './dialogue.vue'
import CustomTextArea from '@/components/aiChat/components/customTextArea'
import publicTable from '@/components/publicTable'
import { Api } from 'api'
import { setIconDragDual } from '@/utils'
import moment from 'moment'

export default {
  components: {
    SuggestQuestion,
    CustomTextArea,
    Dialogue,
    publicTable
  },
  props: {
    activeRouteProp: {
      type: [String, null],
      default: null
    },
    interview: {
      type: Object,
      default() {
        return {}
      }
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sourceType: this.$store.state.aiChat.chatSourceType || (this.source !== undefined && this.source !== null ? this.source : 'global'),
      //zzpSelectBtn: [],
      zzpBtnList: [],
      visible: false,
      fileList: [],
      loading: false,

      selectAttachmentId: '',
      selectRecordingIds: [],
      selectRecordingType: '',
      btnListConfig: {
        1: '原始简历',
        2: '标准简历',
        3: '测评结果',
        4: '面试录音',
        5: '录音文本',
        6: '工作职责',
        7: '任职资格',
        8: '职位名称',
        9: '职位画像',
      },

      // 关联测评弹窗相关数据
      evaluationDialogVisible: false,
      evaluationTableData: [],
      evaluationTableColumns: [
        {
          label: '邀请时间',
          prop: 'createTime',
          showTooltip: true,
          width: 150
        },
        {
          label: '邀请人',
          prop: 'sponsorName',
          showTooltip: true,
          width: 170
        },
        {
          label: '活动名称',
          prop: 'activityName',
          showTooltip: true,
          width: 200
        },
        {
          label: '状态',
          prop: 'userAssessStatus',
          slot: 'userAssessStatus',
          showTooltip: true
        },
        {
          label: '提交时间',
          prop: 'createTime',
          showTooltip: true,
          width: 150
        },
        {
          label: '测评工具',
          prop: 'assessmentTools',
          slot: 'assessmentTools',
          showTooltip: true,
          width: 200
        }
      ],
      evaluationTableConfig: {
        loading: false,
        maxHeight: null,
        height: 400,
        filter: false,
        selection: true,
        selectionFixed: false,
        reserveSelection: false,
        needPagination: false,
        empty: '暂无数据'
      },
      evaluationPaginationConfig: {
        pos: 'right',
        pageSize: 10,
        pageNum: 1,
        total: 100,
        layout: 'total,prev,pager,next,sizes,jumper'
      },
      evaluationSelectList: [],
      evaluationLoading: false,
      evaluationTableLoading: false,

      // 轮询 loading 实例
      pollLoadingInstance: null,

      // 职位画像管理相关数据
      positionProfileDrawerVisible: false,
      profileDialogVisible: false,
      profileList: [],
      profileListLoading: false,
      profileFormLoading: false,
      selectedProfileIds: new Set(),
      editingProfileId: null,
      nextProfileId: 1,
      profileForm: {
        profileName: '',
        profileContent: ''
      },
      profileFormRules: {
        profileName: [{ required: true, message: '请输入画像名称', trigger: 'blur' }],
        profileContent: [{ required: true, message: '请输入画像内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    evaluationSelectListFilter() {
      return this.evaluationSelectList.filter(v => v.type !== 0)
    },
    showSourceSelect() {
      const targetIds = ['2075142831662010369', '2064232480850550786']
      const roleList = this.$store.state.user.userRoleList
      if (!roleList || !roleList.length) return false
      return roleList.some(role =>
        targetIds.includes(String(role.id)) && role.choose === true
      )
    }
  },
  watch: {
    sourceType(val) {
      this.$bus.$emit('sourceType-change', val)
    },
    positionProfileDrawerVisible(val) {
      if (val) {
        // 重置职位画像相关变量（保留selectedProfileIds用于回显）
        this.profileDialogVisible = false
        this.profileList = []
        this.profileListLoading = false
        this.profileFormLoading = false
        this.editingProfileId = null
        this.profileForm = {
          profileName: '',
          profileContent: ''
        }
        // 请求列表
        this.fetchProfileList()
      }
    }
  },
  methods: {
    handleCommand(e) {
      console.log(this.$attrs.interviewProp)
      this.selectAttachmentId = e
      if (this.selectAttachmentId === 4 || this.selectAttachmentId === 5) {
        this.fileList = []
        this.selectRecordingIds = []
        this.audioListInit()
        this.visible = true
        this.selectRecordingType = 'add'
      } else if (this.selectAttachmentId === 1) {
        this.attachmentUpload(e)
      } else if (this.selectAttachmentId === 3) {
        this.openEvaluationDialog()
      } else if (this.selectAttachmentId === 9) {
        // 新增职位画像，清空选中
        this.selectedProfileIds.clear()
        this.positionProfileDrawerVisible = true
      } else {
        const r = this.zzpBtnList.find(item => item.type === e)
        const obj = {
          type: e,
          content: r ? r.content : ''
        }
        this.$store.state.aiChat.zzpSelectBtn.push(obj)
      }
    },

    attachmentUpload(e) {
      const r = this.zzpBtnList.find(item => item.type === e)
      if (r.content) {
        Api.parseAttachment({
          fileUrl: r.content,
          fileName: '简历附件',
          fileType: 'resume'
        }).then(res => {
          if (res.code === '0' && res?.data?.md5) {
            // 开启全局 loading
            this.pollLoadingInstance = this.$loading({
              lock: true,
              text: '附件处理中，请稍候...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            this.pollAttachmentStatus(res.data.md5, 0)
          }
        })
      }
    },

    // 轮询附件状态
    pollAttachmentStatus(md5, count) {
      if (count >= 20) {
        // 关闭 loading
        if (this.pollLoadingInstance) {
          this.pollLoadingInstance.close()
          this.pollLoadingInstance = null
        }
        this.$message.warning('附件处理超时，请稍后重试')
        return
      }

      Api.attachmentStatus({
        md5: md5
      })
        .then(res => {
          if (res.code === '0') {
            if (res.data?.status === 'completed') {
              // 关闭 loading
              if (this.pollLoadingInstance) {
                this.pollLoadingInstance.close()
                this.pollLoadingInstance = null
              }
              if (res.data.content) {
                this.$message.success('附件处理完成')
                // 这里可以添加处理完成后的逻辑
                const obj = {
                  type: 1,
                  content: res.data.content
                }
                this.$store.state.aiChat.zzpSelectBtn.push(obj)
              } else {
                this.$message.error('原始简历解析失败')
              }
            } else {
              // 继续轮询，间隔 2 秒
              setTimeout(() => {
                this.pollAttachmentStatus(md5, count + 1)
              }, 1000)
            }
          } else {
            console.error('附件状态查询失败', res)
            // 关闭 loading
            if (this.pollLoadingInstance) {
              this.pollLoadingInstance.close()
              this.pollLoadingInstance = null
            }
          }
        })
        .catch(err => {
          console.error('轮询出错', err)
          // 关闭 loading
          if (this.pollLoadingInstance) {
            this.pollLoadingInstance.close()
            this.pollLoadingInstance = null
          }
          this.$message.error('原始简历解析失败')
        })
    },

    selectRecordingFn(item) {
      const r = this.recordingIsSelect(item)
      if (!r) {
        const index = this.selectRecordingIds.indexOf(item.id)
        if (index > -1) {
          // 如果已选中，则取消选中
          this.selectRecordingIds.splice(index, 1)
        } else {
          // 如果未选中，则添加到选中列表
          this.selectRecordingIds.push(item.id)
        }
      }
    },
    saveConfirm() {
      if (this.selectRecordingIds.length === 0) {
        this.$message.error('请选择录音。')
        return
      }
      if (this.selectRecordingType === 'add') {
        const obj = {
          type: this.selectAttachmentId,
          content: JSON.stringify(this.selectRecordingIds)
        }
        this.$store.state.aiChat.zzpSelectBtn.push(obj)
      } else if (this.selectRecordingType === 'edit') {
        const obj = this.$store.state.aiChat.zzpSelectBtn.find(val => val.type === this.selectAttachmentId)
        if (obj) {
          obj.content = JSON.stringify(this.selectRecordingIds)
        }
      }
      this.dialogClose()
    },
    dialogClose() {
      this.visible = false
      this.selectAttachmentId = false
      this.selectRecordingIds = []
      this.selectRecordingType = ''
    },
    getBtnName(item) {
      let r = ''
      if (item.type === 1) {
        r = '原始简历'
      } else if (item.type === 2) {
        r = '标准简历'
      } else if (item.type === 3) {
        r = '测评结果'
      } else if (item.type === 4) {
        r = '面试录音'
      } else if (item.type === 5) {
        r = '录音文本'
      } else if (item.type === 6) {
        r = '工作职责'
      } else if (item.type === 7) {
        r = '任职资格'
      } else if (item.type === 8) {
        r = '职位名称'
      } else if (item.type === 9) {
        r = '职位画像'
      }
      return r
    },
    delBtn(i) {
      this.$store.state.aiChat.zzpSelectBtn.splice(i, 1)
    },
    btnIsDisabled(item) {
      let r = false
      for (let i = 0; i < this.zzpBtnList.length; i++) {
        for (let j = 0; j < this.$store.state.aiChat.zzpSelectBtn.length; j++) {
          const obj = this.$store.state.aiChat.zzpSelectBtn.find(val => val.type === item.value)
          if (obj) {
            r = true
            break
          }
        }
      }
      return r
    },
    zzpBtnsClick(item) {
      const id = this.$attrs.interviewProp.resumeId
      if (item.type === 4 || item.type === 5) {
        this.selectAttachmentId = item.type
        try {
          this.selectRecordingIds = JSON.parse(item.content)
        } catch (e) {
          // 兼容旧数据（单个ID字符串）
          this.selectRecordingIds = item.content ? [item.content] : []
        }
        this.fileList = []
        this.audioListInit()
        this.visible = true
        this.selectRecordingType = 'edit'
      } else if (item.type === 1) {
        this.openNewWindow(id, '')
      } else if (item.type === 2) {
        this.openNewWindow(id, 'standardResume')
      } else if (item.type === 3) {
        this.openEvaluationDialog(item)
      } else if (item.type === 9) {
        // 职位画像回显逻辑
        try {
          const profileIds = JSON.parse(item.content)
          if (Array.isArray(profileIds)) {
            // 清空之前的选中
            this.selectedProfileIds.clear()
            // 回显选中的职位画像ID
            profileIds.forEach(id => {
              this.selectedProfileIds.add(id)
            })
          }
        } catch (e) {
          // 如果解析失败，清空选中
          this.selectedProfileIds.clear()
        }
        this.positionProfileDrawerVisible = true
      }
    },
    audioListInit() {
      this.loading = true
      this.fileList = []
      Api.resumeDetailInterview({
        id: this.$attrs.interviewProp.resumeId,
        objectCode: 'resume'
      })
        .then(e => {
          if (e.code == '0' && e.data && e.data instanceof Array) {
            let fileList = []
            // 循环 e.data 数组
            for (let i = 0; i < e.data.length; i++) {
              const item = e.data[i]
              // 判断 evaluateEntityList 是否存在且是数组
              if (item.evaluateEntityList && item.evaluateEntityList instanceof Array) {
                // 循环 evaluateEntityList
                for (let j = 0; j < item.evaluateEntityList.length; j++) {
                  const entityItem = item.evaluateEntityList[j]
                  // 判断 fileDtoList 是否存在且是数组
                  if (entityItem.fileDtoList && entityItem.fileDtoList instanceof Array) {
                    // 循环 fileDtoList 中的每个元素，执行赋值逻辑
                    for (let k = 0; k < entityItem.fileDtoList.length; k++) {
                      const obj = entityItem.fileDtoList[k]
                      const doneData = {
                        status: 'success',
                        name: obj.fileName,
                        title: obj.fileName,
                        path: obj.fileUrl,
                        url: obj.fileUrl,
                        src: obj.fileUrl,
                        multipartUploadRecordDTO: obj.multipartUploadRecordDTO,
                        id: obj.id,
                        taskStatus: obj.taskStatus || 0,
                      }
                      fileList.push(doneData)
                    }
                  }
                }
              }
            }
            this.fileList = fileList
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAttachment() {
      Api.getAttachment({
        resumeId: this.$attrs.interviewProp.resumeId,
        interviewId: this.$attrs.interviewProp.interviewId,
      }).then(res => {
        if (res.code === '0' && res.data && res.data instanceof Array) {
          const list = res.data
          for (let i = 0; i < list.length; i++) {
            list[i].value = list[i].type
            list[i].label = this.btnListConfig[list[i].type]
          }
          this.zzpBtnList = list

          // 默认选中项目318837
          this.addDefaultSelectBtn(8, list) // 职位名称
          this.addDefaultSelectBtn(2, list) // 标准简历
        }
      })
    },
    // 添加默认选中按钮
    addDefaultSelectBtn(type, list) {
      const item = list.find(item => item.type === type)
      if (item) {
        // 检查是否已经选中
        const alreadySelected = this.$store.state.aiChat.zzpSelectBtn.find(item => item.type === type)
        if (!alreadySelected) {
          const obj = {
            type,
            content: item.content || ''
          }
          this.$store.state.aiChat.zzpSelectBtn.push(obj)
        }
      }
    },
    openNewWindow(id, aiInterviewConsultantParam) {
      const tempwindow = window.open()
      const route = this.$router.resolve({
        path: '/newResumeDetail/infor',
        query: {
          id,
          scene: 'candidateManagement',
          aiInterviewConsultantParam
        }
      })
      tempwindow.location = route.href
    },
    convertAudioToText(item) {
      setIconDragDual(true)
      this.$confirmDialog(`历史录音会启动异步转文字，处理完后会有站内信通知您，请关注`, '录音转文字', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'lingdang',
        closeOnClickModal: false,
        customClass: 'customConfirmDialogClass'
      })
        .then(() => {
          this.loading = true
          Api.transcoding({
            id: item.id
          })
            .then(res => {
              if (res.code === '0') {
                this.$message.success('操作成功，转化中')
                this.audioListInit()
              }
            })
            .catch(() => {
              this.loading = false
            })
        })
        .finally(() => {
          setIconDragDual(false)
        })
    },
    recordingIsSelect(item) {
      return (
        (item.multipartUploadRecordDTO === null && item.taskStatus === 0) ||
        item.taskStatus === 3 ||
        (item.multipartUploadRecordDTO &&
          item.multipartUploadRecordDTO.transCode === 'Success' &&
          item.taskStatus === 0) ||
        item.taskStatus === 1 ||
        (item.multipartUploadRecordDTO &&
          item.multipartUploadRecordDTO.transCode != 'Success' &&
          item.multipartUploadRecordDTO.state !== 0)
      )
    },

    // 关联测评弹窗相关方法
    evaluationDialogClose() {
      this.evaluationDialogVisible = false
    },
    triggerFunc(callback, data) {
      let result = true
      if (data.type === 0) {
        result = false
      }
      return callback(result)
    },
    handleEvaluationSelectChange(data) {
      this.evaluationSelectList = data
    },
    getTaskStatusData(value) {
      // 状态映射，根据实际需求调整
      const statusMap = {
        0: { name: '未开始', background: '#86909C' },
        1: { name: '进行中', background: '#165DFF' },
        2: { name: '已完成', background: '#00B42A' },
        3: { name: '已失败', background: '#F53F3F' }
      }
      return statusMap[value] || { name: '未知', background: '#86909C' }
    },
    evaluationConfirm() {
      // const selectList = this.evaluationSelectList.filter(v => v.type !== 0)
      // if (selectList.length > 20) {
      //   this.$message.error('绑定培训记录不可超过20条，请确认后重试')
      //   return
      // }
      // // 这里添加确认逻辑
      // this.$message.success('操作成功')
      if (this.evaluationSelectList.length === 0) {
        this.$message.error('请选择关联测评结果')
        return
      }
      const zzpSelectBtn = this.$store.state.aiChat.zzpSelectBtn

      // 判断 zzpSelectBtn 数组中有没有 type=3 的项
      const existingItem = zzpSelectBtn.find(item => item.type === 3)

      if (existingItem) {
        // 如果有，就覆盖 content
        existingItem.content = JSON.stringify(this.evaluationSelectList)
      } else {
        // 如果没有，就插入新项
        const obj = {
          type: 3,
          content: JSON.stringify(this.evaluationSelectList)
        }
        zzpSelectBtn.push(obj)
      }

      this.evaluationDialogClose()
    },
    openEvaluationDialog(item) {
      this.evaluationSelectList = []
      this.evaluationTableData = []
      this.evaluationDialogVisible = true
      this.evaluationSearch(item)
    },
    evaluationSearch(item) {
      const params = {
        candidateId: this.$attrs.interviewProp?.candidate?.candidateId,
        //candidateId: '1876546447023882242',
        assessStatus: 2
      }
      this.evaluationTableLoading = true
      Api.queryEvaluationRecordList(params)
        .then(res => {
          if (
            res.code === '0' &&
            res?.data?.evaluationRecordListDtos &&
            res?.data?.evaluationRecordListDtos instanceof Array
          ) {
            // 循环reportInfoList把父元素拆成多个
            const flattenedData = []
            res.data.evaluationRecordListDtos.forEach(parent => {
              if (parent.reportInfoList && parent.reportInfoList.length > 0) {
                parent.reportInfoList.forEach(reportItem => {
                  flattenedData.push({
                    ...parent,
                    currentReportInfo: reportItem
                  })
                })
              } else {
                // 如果没有reportInfoList，仍然包含父元素
                flattenedData.push({
                  ...parent,
                  currentReportInfo: null
                })
              }
            })
            this.evaluationTableData = flattenedData
            this.$nextTick(() => {
              if (item) {
                this.setEvaluationSelection(item)
              }
            })
            console.log('flattenedData', flattenedData)
          } else {
            this.evaluationTableData = []
          }
          this.evaluationTableLoading = false
        })
        .catch(() => {
          this.evaluationTableLoading = false
          this.evaluationTableData = []
        })
    },
    setEvaluationSelection(item) {
      if (item.content) {
        const selects = JSON.parse(item.content)
        if (this.$refs.evaluationTable && this.$refs.evaluationTable.$children[0]) {
          this.$refs.evaluationTable.$children[0].clearSelection()
          // 循环 evaluationTableData 的每一个元素
          this.evaluationTableData.forEach(tableItem => {
            // 再循环 selects
            selects.forEach(selectItem => {
              // 判断两重循环的 assessId 和 currentReportInfo.reportId 是否相同
              if (
                tableItem.assessId &&
                selectItem.currentReportInfo &&
                tableItem.currentReportInfo &&
                tableItem.assessId === selectItem.assessId &&
                tableItem.currentReportInfo.reportId === selectItem.currentReportInfo.reportId
              ) {
                this.$refs.evaluationTable.$children[0].toggleRowSelection(tableItem)
              }
            })
          })
        }
      }
    },
    getTag(data = [], type) {
      if (data.length > 1) {
        if (`${data[0].title}${data[1].title}`.length > 9) {
          return {
            data: type === 'ALL' ? data : [data[0]],
            show: true,
            remain: data.length - 1
          }
        }
        return {
          data: type === 'ALL' ? data : data.slice(0, 2),
          show: data.length !== 2,
          remain: data.length - 2
        }
      }
      return {
        data,
        show: false,
        remain: 0
      }
    },
    getScaleList(data = [], solutionList = [], scaleList = []) {
      solutionList.forEach(v => {
        data.push({
          ...v,
          type: 1,
          title: v.solutionName
        })
      })
      scaleList.forEach(v => {
        data.push({
          ...v,
          type: 2,
          title: v.scaleName
        })
      })
      return data
    },
    dynamicHtml(item) {
      let r = ''
      if (item.content) {
        const arr = JSON.parse(item.content)
        if (arr instanceof Array) {
          for (let i = 0; i < arr.length; i++) {
            const str = `<p>${arr[i].activityName}；${arr[i].createTime}；${arr[i].currentReportInfo?.scaleName}；</p>`
            r = r + str
          }
        }
      }
      return r
    },
    getRecordingTooltip(item) {
      try {
        const ids = JSON.parse(item.content)
        if (Array.isArray(ids)) {
          return `已选择 ${ids.length} 个录音`
        }
      } catch (e) {
        // 兼容旧数据（单个ID字符串）
        return '已选择 1 个录音'
      }
      return '未选择录音'
    },
    getProfileTooltip(item) {
      try {
        const profileIds = JSON.parse(item.content)
        if (Array.isArray(profileIds)) {
          return `已选择 ${profileIds.length} 个职位画像`
        }
      } catch (e) {
        return '已选择职位画像'
      }
      return '未选择职位画像'
    },

    // 职位画像管理相关方法
    showAddForm() {
      this.editingProfileId = null
      this.profileForm = { profileName: '', profileContent: '' }
      this.profileDialogVisible = true
      this.$nextTick(() => {
        this.$refs.profileFormRef && this.$refs.profileFormRef.clearValidate()
      })
    },
    editProfile(id) {
      const profile = this.profileList.find(p => p.id === id)
      if (!profile) return
      this.editingProfileId = id
      this.profileForm = {
        profileName: profile.profileName,
        profileContent: profile.profileContent
      }
      this.profileDialogVisible = true
    },
    cancelEdit() {
      this.editingProfileId = null
      this.profileDialogVisible = false
      this.profileForm = { profileName: '', profileContent: '' }
      this.$refs.profileFormRef && this.$refs.profileFormRef.resetFields()
    },
    saveProfile() {
      this.$refs.profileFormRef.validate(valid => {
        if (valid) {
          if (this.editingProfileId) {
            // 编辑职位画像
            this.profileFormLoading = true
            Api.positionProfileUpdate({
              id: this.editingProfileId,
              profileName: this.profileForm.profileName,
              profileContent: this.profileForm.profileContent
            }).then(res => {
              if (res.code === '0') {
                this.$message.success('编辑成功')
                this.cancelEdit()
                this.fetchProfileList()
              } else {
                this.$message.error('编辑失败')
              }
            }).catch(err => {
              this.$message.error('编辑失败：' + (err.message || '未知错误'))
            }).finally(() => {
              this.profileFormLoading = false
            })
          } else {
            // 新增职位画像
            this.profileFormLoading = true
            Api.positionProfileAdd({
              profileName: this.profileForm.profileName,
              profileContent: this.profileForm.profileContent
            }).then(res => {
              if (res.code === '0' && res.data?.profileName && res.data?.profileContent) {
                this.$message.success('新增成功')
                this.cancelEdit()
                this.fetchProfileList()
              } else {
                this.$message.error('新增失败')
              }
            }).catch(err => {
              this.$message.error('新增失败：' + (err.message || '未知错误'))
            }).finally(() => {
              this.profileFormLoading = false
            })
          }
        }
      })
    },
    deleteProfile(id) {
      this.$confirm('确定要删除该职位画像吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.profileListLoading = true
        Api.positionProfilelDelete({ id }).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功')
            this.selectedProfileIds.delete(id)
            this.fetchProfileList()
          } else {
            this.$message.error('删除失败')
          }
        }).catch(err => {
          this.$message.error('删除失败：' + (err.message || '未知错误'))
        }).finally(() => {
          this.profileListLoading = false
        })
      }).catch(() => {})
    },
    deleteSelected() {
      if (this.selectedProfileIds.size === 0) return
      this.$confirm(`确定要删除选中的 ${this.selectedProfileIds.size} 个职位画像吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.profileListLoading = true
        const ids = Array.from(this.selectedProfileIds)
        Api.positionProfilelBatchDelete({ ids }).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功')
            this.selectedProfileIds.clear()
            this.fetchProfileList()
          } else {
            this.$message.error('批量删除失败')
          }
        }).catch(err => {
          this.$message.error('批量删除失败：' + (err.message || '未知错误'))
        }).finally(() => {
          this.profileListLoading = false
        })
      }).catch(() => {})
    },
    toggleSelection(id) {
      if (this.selectedProfileIds.has(id)) {
        this.selectedProfileIds.delete(id)
      } else {
        this.selectedProfileIds.add(id)
      }
      this.$forceUpdate()
    },
    toggleSelectAll() {
      if (this.selectedProfileIds.size === this.profileList.length) {
        this.selectedProfileIds.clear()
      } else {
        this.profileList.forEach(p => this.selectedProfileIds.add(p.id))
      }
      this.$forceUpdate()
    },
    toggleDefault(profile) {

      this.profileListLoading = true

      // 根据当前isDefault状态调用不同的API
      if (profile.isDefault) {
        // 如果当前是默认，调用取消默认接口
        Api.positionProfilelCancelDefault({ id: profile.id }).then(res => {
          if (res.code === '0') {
            this.$message.success('已取消默认')
            this.fetchProfileList()
          } else {
            this.$message.error('取消默认失败')
          }
        }).catch(err => {
          this.$message.error('取消默认失败：' + (err.message || '未知错误'))
        }).finally(() => {
          this.profileListLoading = false
        })
      } else {
        // 如果当前不是默认，调用设置默认接口
        Api.positionProfilelSetDefault({ id: profile.id }).then(res => {
          if (res.code === '0') {
            this.$message.success('已设为默认')
            this.fetchProfileList()
          } else {
            this.$message.error('设置默认失败')
          }
        }).catch(err => {
          this.$message.error('设置默认失败：' + (err.message || '未知错误'))
        }).finally(() => {
          this.profileListLoading = false
        })
      }
    },
    handleCardClick(event, id) {
      if (event.target.closest('.el-checkbox') || event.target.closest('.profile-actions')) {
        return
      }
      this.toggleSelection(id)
    },
    confirmSelection() {
      const selected = this.profileList.filter(p => this.selectedProfileIds.has(p.id))
      if (selected.length === 0) {
        this.$message.warning('请至少选择一个职位画像')
        return
      }

      // 检查是否已经有职位画像素材
      const existingItem = this.$store.state.aiChat.zzpSelectBtn.find(item => item.type === 9)

      // 只保存id数组
      const selectedIds = selected.map(p => p.id)

      if (existingItem) {
        // 如果已存在，更新content
        existingItem.content = JSON.stringify(selectedIds)
      } else {
        // 如果不存在，添加新项
        const obj = {
          type: 9,
          content: JSON.stringify(selectedIds)
        }
        this.$store.state.aiChat.zzpSelectBtn.push(obj)
      }

      this.$message.success(`已引用 ${selected.length} 个职位画像`)
      this.positionProfileDrawerVisible = false
    },
    fetchProfileList(type) {
      this.profileList = []
      this.profileListLoading = true
      Api.positionProfilelList({
        pageNum: 1,
        pageSize: 9999
      }).then(res => {
        if (res.code === '0' && res.data?.list) {
          const defaultProfileIds = []
          this.profileList = res.data.list.map(item => {
            // 收集isDefault=1的id
            if (item.isDefault === 1) {
              defaultProfileIds.push(item.id)
            }
            return {
              id: item.id,
              profileName: item.profileName,
              profileContent: item.profileContent,
              isDefault: item.isDefault === 1
            }
          })
          // 更新 nextProfileId
          if (this.profileList.length > 0) {
            this.nextProfileId = Math.max(...this.profileList.map(p => p.id)) + 1
          }
          if (type === 'init' && defaultProfileIds.length > 0) {
            const obj = {
              type: 9,
              content: JSON.stringify(defaultProfileIds)
            }
            this.$store.state.aiChat.zzpSelectBtn.push(obj)
          }
          // 处理默认职位画像
          console.log('默认职位画像ID列表:', defaultProfileIds)
        }
      }).catch(err => {
        this.$message.error('获取职位画像列表失败：' + (err.message || '未知错误'))
      }).finally(() => {
        this.profileListLoading = false
      })
    }
  },
  created() {
    this.$bus.$emit('sourceType-change', this.sourceType)
  },
  mounted() {
    this.getAttachment()
    this.fetchProfileList('init')
  }
}
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";

.c-content {
  padding: 16px 0 16px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  .content_wrap {
    flex-grow: 1;
    overflow: hidden;
    position: relative;
  }
  .textarea_wrap {
    flex-shrink: 0;
    padding-right: 16px;
  }
}
.source-select-wrap {
  margin-bottom: 5px;
  padding-right: 16px;
  ::v-deep .el-input__inner {
    border-radius: 5px;
  }
}
.zzpBtns {
  margin-bottom: 5px;
  .el-button {
    margin-left: 0;
    margin-right: 5px;
    margin-bottom: 5px;
    position: relative;
    i {
      font-size: 18px;
      position: absolute;
      top: -5px;
      right: -5px;
      display: none;
    }
    &:hover {
      i {
        display: block;
      }
    }
  }
}
.recording-box.file-list {
  height: 228px;
  .file-item {
    width: 100%;
    border: 1px solid #e5e6eb;
    margin-bottom: 12px;
    border-radius: 4px;
    //height: 38px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      border: 1px solid #002aff;
    }
    &.selectRecording {
      border: 1px solid #002aff;
    }
    .file-item-l {
      display: flex;
      justify-content: space-between;
      align-items: center;
      //width: 360px;
      flex: 1;
      height: 36px;
      padding: 0px 12px;
      //background: #f2f3f5;
      border-radius: 4px 4px 4px 4px;
      width: 400px;
      overflow: hidden; /* 隐藏溢出内容 */
      text-overflow: ellipsis; /* 显示省略号 */
      white-space: nowrap; /* 不换行 */
    }
    .file-item-l01 {
      width: 100%;
      display: flex;
      align-items: center;
      .file-item-name {
        display: inline-block;
        width: 470px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
    }
    .file-item-l02 {
      font-size: 12px;
    }
    .file-item-r {
      display: flex;
      margin-left: 12px;
      height: 36px;
      i {
        margin-top: 8px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 2px;
        cursor: pointer;
        &:hover {
          background: #eceff6;
          border-radius: 50%;
        }
      }

      .icon-shanshu16,
      .icon-xiazai-1 {
        color: #4e5969;
      }
    }
    .file-item-r.recording {
      padding: 0 10px;
      background: #333;
      color: #fff;
      border-radius: 3px;
    }
    .file-type {
      margin-top: 2px;
      margin-right: 12px;
    }
    .fileItemHeader {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f7f8fa;
    }
    .file-item-r {
      display: flex;
      margin-left: 12px;
      height: 36px;
      align-items: center;
      i {
        margin-top: 8px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 2px;
        cursor: pointer;
        &:hover {
          background: #eceff6;
          border-radius: 50%;
        }
      }
    }
    .file-item-r.recording {
      padding: 0 10px;
      background: #333;
      color: #fff;
      border-radius: 3px;
    }
  }
  .content-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 50px;
  }
}
.recordingNoSelect {
  border-color: #e5e6eb !important;
  cursor: default !important;
  .file-item-l01 {
    opacity: 0.5 !important;
  }
}

// 关联测评弹窗样式
.related-evaluation {
  ::v-deep .el-dialog__header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #fafafc;
    .default {
      display: none;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 16px 24px;
    .el-table {
      .tag-wrapper {
        .tag-total {
          margin-right: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #165dff;
        }
        .tag-more {
          cursor: pointer;
        }
      }
      thead,
      tbody {
        .cell {
          font-size: 12px;
          font-weight: 400;
          color: #4e5969;
          align-items: center;
        }
      }
      tbody {
        color: #1d2129;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    height: 56px;
    border-top: 0 !important;
    .btn-right {
      display: flex;
      justify-content: flex-end;
    }
    .el-button {
      height: 28px;
      padding: 0 20px;
      width: auto;
      span {
        display: inline-block;
        height: 28px;
        line-height: 28px;
      }
    }
  }
}
.el-tag {
  margin-right: 4px;
  height: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #1d2129;
  &.programme {
    color: #3491fa;
    background: #e8f7ff;
  }
  &.scale {
    color: #00b42a;
    background: #e8ffea;
  }
  span {
    display: inline-block;
    height: 20px;
    background: #f2f3f5;
  }
  &:last-child {
    margin-right: 0;
  }
}
.status {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  background: #86909c;
  border-radius: 2px 2px 2px 2px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  padding: 0 8px;
}

// 职位画像管理样式
.position-profile-drawer {
  display: flex;
  flex-direction: column;
  height: 100%;

  .toolbar {
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;

    .toolbar-actions {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
    }

    .selection-info {
      margin-top: 12px;
      background-color: #e6f7ff;
      border: 1px solid #91d5ff;
      border-radius: 4px;
      padding: 8px 16px;
      color: #1890ff;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .content-area {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
  }

  .profile-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .profile-item {
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 16px;
    background-color: #fafafa;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      border-color: #1890ff;
    }

    &.selected {
      border-color: #1890ff;
      background-color: #e6f7ff;
    }

    .profile-item-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 8px;

      .profile-name {
        flex: 1;
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }

      .profile-actions {
        display: flex;
        gap: 4px;

        .el-button {
          padding: 6px;
          color: #666;

          &:hover {
            color: #1890ff;
          }

          &.delete-btn:hover {
            color: #ff4d4f;
          }

          &.default-active {
            color: #52c41a;
          }
        }
      }
    }

    .profile-content {
      color: #666;
      font-size: 14px;
      line-height: 1.6;
      padding-left: 30px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;
  }
}
.profileDialogForm{
  ::v-deep .el-form-item__label{
    margin-right: 0;
  }
}
</style>
<style>
.tag-all.el-tooltip__popper.is-dark {
  background: #fff;
}
.tag-all.el-tooltip__popper.is-dark .tag-type {
  font-size: 12px;
  font-weight: 400;
  color: #4e5969;
  line-height: 20px;
  margin: 12px 0 4px 0;
}
.tag-all.el-tooltip__popper.is-dark .my-tag {
  background: #f2f3f5;
  border-radius: 2px 2px 2px 2px;
  font-size: 12px;
  font-weight: 400;
  color: #1d2129;
  line-height: 20px;
  display: inline-block;
  padding: 0 8px;
  margin-right: 4px;
}
.tag-all.el-tooltip__popper.is-dark .my-tag.programme {
  color: #3491fa;
  background: #e8f7ff;
}
.tag-all.el-tooltip__popper.is-dark .my-tag.scale {
  color: #00b42a;
  background: #e8ffea;
}
.tag-all.el-tooltip__popper.is-dark .my-tag:last-child {
  margin-right: 0;
}
.tag-all.el-tooltip__popper.is-dark .popper__arrow {
  border-top-color: #fff !important;
}

/* 职位画像管理 Drawer 样式 */
.position-profile-drawer-wrapper.el-drawer {
  z-index: 2010 !important;
}
.position-profile-drawer-wrapper .el-drawer__header {
  margin-bottom: 0;
  padding: 20px 24px;
  border-bottom: 1px solid #e8e8e8;
}
.position-profile-drawer-wrapper .el-drawer__body {
  padding: 0;
  height: calc(100% - 61px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.position-profile-drawer-wrapper .el-drawer__header{
  display: flex !important;
}
.position-profile-drawer-wrapper .position-profile-drawer {
  flex: 1;
  overflow: hidden;
}
.position-profile-drawer-wrapper .drawer-footer {
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  text-align: right;
  background: #fff;
}
.position-profile-drawer-wrapper .el-drawer__footer{
  display: none;
}
</style>
